import { useKeycloak } from '@react-keycloak/web';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../components/Loader';
import PageWrapper from '../components/PageWrapper';
import { ROUTES } from '../routes/routes';

const LoginPage = () => {
    const { initialized, keycloak } = useKeycloak();

    if (initialized) {
        if (!keycloak?.authenticated) {
            keycloak?.login();
        } else {
            return <Redirect to={ROUTES.DASHBOARD} />;
        }
    }

    return (
        <PageWrapper>
            <Loader />
        </PageWrapper>
    );
};

export default LoginPage;
